/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DevRobotIcon32Regular = forwardRef('DevRobotIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M22.25 18a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z" }),
        React.createElement("path", { d: "M11.5 19.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 4.266a2.25 2.25 0 1 0-2 0V7h-5a6 6 0 0 0-6 6v4H1a1 1 0 1 0 0 2h3v6a6 6 0 0 0 6 6h12a6 6 0 0 0 6-6v-6h3a1 1 0 1 0 0-2h-3v-4a6 6 0 0 0-6-6h-5V4.266ZM10 9h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4V13a4 4 0 0 1 4-4Z" })));
});
